exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".arrangement-info-tooltip-wpr{min-height:50px}.arrangement-info-tooltip-wpr .text-hd{background:#11b95c;color:#fff}.arrangement-info-tooltip-wpr .text-hd th{padding:3px 5px}.arrangement-info-tooltip-wpr .border-row{border-top:1px solid #ddd;border-bottom:1px solid #ddd}.arrangement-info-tooltip-wpr .text-td{padding:3px 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dfdbefe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/operation/arrangeTooltips.vue
// module id = 900
// module chunks = 23